query GetYouTubeSpeedPanel {
  panel: StreamToolsGetYouTubeSpeedPanel {
    defaultLevel
    liveAllowed
    brakeEnabled
    dailyBudgetUnits
    dailyBudgetSaved
    demoHoldbackSlots
    appChatLimit
    appChatLimitSaved
    appChatLimitMax
    accountChatLimit
    accountChatLimitSaved
    updatedByEmail
    updatedAt
    pacificDay
    unitsToday
    resetsAt
    brakeCapLevel
    brakeCapSince
    quotaExhaustedAt
    slotsInUse
    sessions {
      sessionId
      accountId
      accountEmail
      startedByEmail
      channelId
      channelTitle
      scope
      eventId
      eventName
      startedAt
      lastReadAt
      unitsUsed
      level
      hot
      stale
      demoExempt
      foreignEvent
      countsTowardAppLimit
      countsTowardAccountLimit
    }
  }
}
